import { createSelector } from "@reduxjs/toolkit";

const selectUnreadProviderRequestsCount = (state) => {
  return state.providerRequests.unreadProviderRequestsCount;
};

const selectIsUnreadProviderRequest = (state) => {
  return !!state?.providerRequests?.unreadProviderRequestsCount;
};

export const manageProviderRequestsSelector = createSelector(
  [selectUnreadProviderRequestsCount, selectIsUnreadProviderRequest],
  (unreadProviderRequestsCount, isUnreadProviderRequest) => ({
    unreadProviderRequestsCount,
    isUnreadProviderRequest,
  })
);
